module.exports = __webpack_public_path__ + "static/media/uwaterloo.18449422.png";